"use client";

// Den Service Worker anmelden (wie im Agent): erst nach dem Laden, damit
// er dem ersten Bild keine Bandbreite nimmt. Fehler sind still — ohne
// Worker laeuft die Anwendung genauso, nur ohne Offline-Seite und Push.
import { useEffect } from "react";

export function ServiceWorker() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const anmelden = () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
    };
    if (document.readyState === "complete") {
      anmelden();
      return;
    }
    window.addEventListener("load", anmelden, { once: true });
    return () => window.removeEventListener("load", anmelden);
  }, []);
  return null;
}
